const validators = {   
  name: {
    length: {
      minimum: 5,
      message: "^whitemonday.errors.send_puzzle_form.name"
    }
  }, 
  address: {
    length: {
      minimum: 5,
      message: "^whitemonday.errors.send_puzzle_form.location"
    }
  }  
};

export default validators;
